export const agriiProtectors = {
    state: {
        status: 'idle',
        agriiProtectors: [],
        areAllFetched: false,
        pagination: {
            limit: 20,
            page: 1
        },
        query: {}
    },
    mutations: {
        SET_AGRIIPROTECTORS_STATUS(state, status) {
            state.status = status
        },
        SET_AGRIIPROTECTORS(state, agriiProtectors) {
            state.agriiProtectors = agriiProtectors
        },
        SET_AGRIIPROTECTORS_QUERY(state, payload) {
            this.$vue.set(state.query, payload.name, payload.value)
        },
        REMOVE_AGRIIPROTECTORS_QUERY_ELEMENT(state, payload) {
            this.$vue.delete(state.query, payload)
        },
        SET_AGRIIPROTECTORS_PAGINATION_PAGE(state, page) {
            state.pagination.page = page
        },
        SET_AGRIIPROTECTORS_ALL_FETCHED(state, areAllFetched) {
            state.areAllFetched = areAllFetched
        }
    },
    actions: {
        fetchAgriiProtectors({ state, commit, dispatch, getters }) {
            // prevent multiple requests at same time
            commit('SET_AGRIIPROTECTORS', null)
            commit('SET_AGRIIPROTECTORS_STATUS', 'loading')
            return dispatch('resetAgriiProtectorsPagination').then(() => {
                return this.$api.get(`api/agrii-protectors.json?${getters.agriiProtectorsQueryString}`).then((response) => {
                    commit('SET_AGRIIPROTECTORS', response.data.data)
                    commit('SET_AGRIIPROTECTORS_ALL_FETCHED', response.data.total_count ? response.data.total_count <= state.agriiProtectors.length : response.data.data.length === 0)
                    commit('SET_AGRIIPROTECTORS_STATUS', 'idle')
                }).catch(error => {
                    commit('SET_AGRIIPROTECTORS_STATUS', 'error')
                    return Promise.reject(error)
                })
            })
        },
        fetchAgriiProtectorsNextPage({ state, commit, getters }) {
            if(state.areAllFetched) {
                return false
            }
            commit('SET_AGRIIPROTECTORS_STATUS', 'loadingMore')
            commit('SET_AGRIIPROTECTORS_PAGINATION_PAGE', state.pagination.page + 1)
            return this.$api.get(`api/agrii-protectors.json?${getters.agriiProtectorsQueryString}`).then((response) => {
                commit('SET_AGRIIPROTECTORS', state.agriiProtectors.concat(...response.data.data))
                commit('SET_AGRIIPROTECTORS_ALL_FETCHED', response.data.total_count ? response.data.total_count <= state.agriiProtectors.length : response.data.data.length === 0)
                commit('SET_AGRIIPROTECTORS_STATUS', 'idle')
            }).catch(error => {
                commit('SET_AGRIIPROTECTORS_STATUS', 'error')
                return Promise.reject(error)
            })
        },
        setAgriiProtectorsSearchQuery({ state, commit }, payload) {
            // check if payload has valid properties
            if(Object.prototype.hasOwnProperty.call(payload, 'name') &&
               Object.prototype.hasOwnProperty.call(payload, 'value')) {
                commit('SET_AGRIIPROTECTORS_QUERY', payload)
            } else {
                console.error('Invalid payload')
            }
        },
        resetAgriiProtectorsQuery({ commit, dispatch }) {
            commit('SET_AGRIIPROTECTORS_ALL_FETCHED', false)
            return dispatch('resetFromInitialState', {
                module: 'agriiProtectors',
                object: 'query'
            })
        },
        resetAgriiProtectorsPagination({ commit, dispatch }) {
            commit('SET_AGRIIPROTECTORS_ALL_FETCHED', false)
            return dispatch('resetFromInitialState', {
                module: 'agriiProtectors',
                object: 'pagination'
            })
        },
        resetAgriiProtectorsFavorite({ commit }) {
            commit('REMOVE_AGRIIPROTECTORS_QUERY_ELEMENT', 'favorite')
        }
    },
    getters: {
        agriiProtectorsStatus: (state) => {
            return state.status
        },
        agriiProtectors: (state) => {
            if(state.agriiProtectors) {
                return state.agriiProtectors
            }
        },
        agriiProtectorsQuery: (state) => {
            return state.query
        },
        agriiProtectorsQueryString: (state) => {
            const pagination = `page=${state.pagination.page}&limit=${state.pagination.limit}`
            const params = Object.entries(state.query)
                .filter(([key, value]) => value !== '')
                .map(([key, val]) => `${key}=${encodeURIComponent(val)}`)
                .join('&')
            return `${pagination}&${params}`
        }
    }
}
